import styled from 'styled-components';

const DataSetResponseEditStyles = styled.div``;

export default DataSetResponseEditStyles;
